import { Stack } from './Stack';
export class UserAction {
}
const MAX_ACTION_STACK = 50;
export class UndoRedoService {
    constructor() {
        this.normalStack = new Stack({ limit: MAX_ACTION_STACK });
        this.reverseStack = new Stack({ limit: MAX_ACTION_STACK });
        this._isLocked = false;
    }
    /**
     * Add action to normal stack
     * @param action IUserAction = User Interface Action
     */
    add(action) {
        if (action && !this._isLocked) {
            this.normalStack.add(action);
        }
    }
    /**
     * Prevent items to be added on stack by locking it
     */
    lock() {
        this._isLocked = true;
    }
    /**
     * Release lock e enable items to be added
     */
    unlock() {
        this._isLocked = false;
    }
    /**
     * Undo action from normal stack
     */
    undo() {
        const removed = this.normalStack.remove();
        if (removed) {
            removed.undo(removed.data);
            this.reverseStack.add(removed);
        }
        return removed;
    }
    /**
     * Redo action from reverse stack
     */
    redo() {
        const removed = this.reverseStack.remove();
        if (removed) {
            removed.execute(removed.data);
            this.normalStack.add(removed);
        }
        return removed;
    }
    /*
    * Get Normal Stack Instance
    */
    getNormalStack() {
        return this.normalStack;
    }
    /*
    * Get Redo Stack Instance
    */
    getReverseStack() {
        return this.reverseStack;
    }
    isLocked() {
        return this._isLocked;
    }
    /**
     * Clear all stack actions
     */
    clear() {
        this.normalStack.clear();
        this.reverseStack.clear();
    }
}
